import { ReactNode } from 'react'
import { Box, Flex, Text } from '@radix-ui/themes'
import clsx from 'clsx'
import { cn } from '@/lib/utils'
import { getMarksStyle } from '@/utils/style'

export interface StatisticItem {
  title: string
  value: string | number
  icon: string | ReactNode
  valueSuffix?: string
}

interface StatisticProps {
  data?: StatisticItem[]
  isLoading?: boolean
}

export default function Statistic({ data, isLoading = false }: StatisticProps) {
  return (
    <>
      <Flex
        direction='row'
        gap='4'
        className='w-full flex-wrap'
        justify='between'
      >
        {data?.map((item) => (
          <Box
            key={item.title}
            className={cn(
              'w-1/4 min-w-[200px] flex-1 rounded-md border border-gray-200 bg-white p-4'
            )}
          >
            <Flex direction='row' gap='4' className='w-full'>
              {typeof item.icon === 'string' ? (
                <img
                  src={item.icon}
                  alt={item.title}
                  width={48}
                  height={48}
                  className='h-[48px]'
                />
              ) : (
                <div className='size-[48px]'>{item.icon}</div>
              )}

              <Flex direction='column' gap='2' className='w-full'>
                <Text className='text-sm font-[300]'>{item.title}</Text>
                {!isLoading && (
                  <Text
                    className={clsx(
                      'font-mundial text-[40px] font-[300]',
                      [
                        'Average practice test marks',
                        'Average mock exam marks',
                        'Average Accuracy',
                      ].includes(item.title) && item.value !== 'N/A'
                        ? getMarksStyle(Number(item.value))
                        : 'text-[#002652]'
                    )}
                  >
                    {item.value}
                    {!!item?.valueSuffix && (
                      <span className='text-[32px]'>{item?.valueSuffix}</span>
                    )}
                  </Text>
                )}
              </Flex>
            </Flex>
          </Box>
        ))}
      </Flex>
    </>
  )
}
